import React, { useState } from 'react';
import clsx from 'clsx';
import { BLOCKS } from '@contentful/rich-text-types';
import { TrackedExpandableContext } from '@objectiv/tracker-react';

import { tildeToSoftHyphen } from '~utils/string';
import { useStructuredData } from '~hooks/useStructuredData';
import { RichContent } from '../RichContent';

import * as styles from './BaseFaq.module.css';

export type BaseFaqQuestion = {
  question: string;
  answer: string;
};

type BaseFaqProps = {
  className?: string;
  questions: BaseFaqQuestion[];
};

const FaqItem: React.FC<BaseFaqQuestion> = ({ question, answer }) => {
  const [open, setOpen] = useState<boolean>(false);

  return (
    <TrackedExpandableContext
      objectiv={{ Component: 'div', id: question, isVisible: open }}
      className={clsx(styles.faqItem, open && styles.open)}
    >
      <div className={styles.question} onClick={() => setOpen(!open)}>
        {tildeToSoftHyphen(question)}
      </div>
      <div className={styles.contentWrapper}>
        <div className={styles.content}>
          <RichContent
            className={styles.answer}
            content={{ raw: answer }}
            renderNode={{
              [BLOCKS.PARAGRAPH]: (_, children) => <p className={styles.paragraph}>{children}</p>,
              [BLOCKS.UL_LIST]: (_, children) => <ul className={styles.list}>{children}</ul>,
            }}
          />
        </div>
      </div>
    </TrackedExpandableContext>
  );
};

export const BaseFaq: React.FC<BaseFaqProps> = ({ className, questions }) => {
  const { getFAQStructuredData } = useStructuredData();

  return (
    <div className={className}>
      <script
        type='application/ld+json'
        dangerouslySetInnerHTML={{ __html: JSON.stringify(getFAQStructuredData(questions)) }}
      />
      {questions?.map(({ question, answer }) => <FaqItem key={question} question={question} answer={answer} />)}
    </div>
  );
};
